"use client"
import {
  TabMenu as DSTabMenu,
  TabMenuItem as DSTabMenuItem,
  type ItemRenderLinkComponent,
  type TabMenuItemProps,
  TabMenuItemTitle,
} from "@opensea/ui-kit"
import { Link } from "../Link"

export const TabMenu = DSTabMenu

export const TabMenuItem = ({
  className,
  active,
  size = "md",
  children,
  ...rest
}: TabMenuItemProps) => {
  return (
    <DSTabMenuItem
      active={active}
      className={className}
      renderLink={Link as ItemRenderLinkComponent}
      size={size}
      {...rest}
    >
      {children}
    </DSTabMenuItem>
  )
}

export { TabMenuItemTitle }
